import Api from './Api';
import { getToken } from './auth';

const setLogos = async (
  file: File,
  type: 'logo' | 'profile_logo',
  sid: string
) => {
  const token = getToken();

  const formData = new FormData();
  formData.append(type, file);

  const data = await Api.post(`/upload-logo/${sid}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  });

  return data.status === 200;
};

export default setLogos;
